import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json';
let baseURL;
const http = {}

// if ( process.env.NODE_ENV !== 'production' ) {
//     baseURL = 'http://172.27.3.204/server-route/' 
// }else { 
//     baseURL = 'http://cm.qingting1.com/server-route/'
// }

baseURL=process.env.API_HOST

axios.defaults.baseURL = baseURL
http.get = (url,params={})=>{
    return new Promise((resolve, reject)=>{
    axios.get(url, {params: params}).then(res=>{
        resolve(res.data)
    }).catch(err=>{
        reject(err)
    })
    })
}
http.gets = (url,params={})=>{
  return new Promise((resolve, reject)=>{
  axios.get(url, {params: params,responseType:'blob'}).then(res=>{
      resolve(res.data)
  }).catch(err=>{
      reject(err)
  })
  })
}
http.post = (url, params = {})=>{
    return new Promise((resolve, reject)=>{
    axios.post(url, params, {
        headers: {
       
        }
    }).then(res=>{
        resolve(res.data)
    }).catch(err=>{
        reject(err)
    })
    })
}
http.postFormData = (url, params = {})=>{
    return new Promise((resolve, reject)=>{
      axios.post(url, params, {
        transformRequest: [
          function(oldData){
            let newStr = ''
            for (let item in oldData){
              newStr += encodeURIComponent(item) + '=' + encodeURIComponent(oldData[item]) + '&'
            }
            newStr = newStr.slice(0, -1)
            return newStr
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(res=>{
        resolve(res.data)
      }).catch(err=>{
        reject(err)
      })
    })
  } 
 
axios.interceptors.request.use(function (config) {
    if(config && config.params){
      config.params.timestamp = new Date().getTime();
    }
    if(config && config.data && config.method !== 'put' && config.headers['Content-type'] !=="application/x-www-form-urlencoded"){
      config.data.timestamp = new Date().getTime();
    }
    // config.headers['Authentication']="3454dfb35c124ce9829e6679dc81729a"
    config.headers['Authentication']=(JSON.parse(localStorage.getItem('user')))&&(JSON.parse(localStorage.getItem('user'))).token||""
    return config;
  })
axios.interceptors.response.use(
    response => { 
        return response 
    }, error => {
        return Promise.reject(error);
    }
)
export default http


// WEBPACK FOOTER //
// ./src/api/http.js